import React from 'react'
// libs
import styled from 'styled-components'
// components
import Column from './components/Column'
import GroupedColumn from './components/GroupedColumn'
// hooks
import { useCurrentForm, useCurrentTable } from 'hooks'
// containers
import { RiskTemplateAPIContext } from 'containers/Risks/RiskTemplate/Edit/layers/API'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
`

/** Render content for fieldLink */

const TableForm: React.FC = () => {
  const { fieldLinks } = useCurrentTable()
  const { fieldLink, primaryFieldLink } = useCurrentForm()

  const { riskTemplate } = React.useContext(RiskTemplateAPIContext)

  const isMainForm = fieldLink.fieldGroups.some(({ groupedByEntityId }) => groupedByEntityId === riskTemplate.id)

  //  get fieldLinks on which current primary fieldLink grouped
  const fieldGroupsIds = React.useMemo(() => {
    const fieldLinksMap = new Map<string, { id: string; position: number }>()

    for (const link of fieldLinks) {
      if (!link.primary) {
        continue
      }
      fieldLinksMap.set(link.field.entityId, { id: link.id, position: link.position })
    }

    return primaryFieldLink.fieldGroups
      .filter(({ groupedByEntityId }) => groupedByEntityId !== riskTemplate.id)
      .map((fieldGroup) => fieldLinksMap.get(fieldGroup.groupedByEntityId) ?? null)
      .filter((fieldLink) => fieldLink)
      .sort((a, b) => a.position - b.position)
      .map((fieldLink) => fieldLink.id)
  }, [primaryFieldLink.fieldGroups, riskTemplate.id, fieldLinks])

  const isMultiGrouping = fieldGroupsIds.length > 1
  const groupedByIds = fieldLink.primary || isMultiGrouping ? fieldGroupsIds : [primaryFieldLink.id]

  return (
    <Wrapper className='form'>
      {isMainForm ? (
        <Column />
      ) : (
        groupedByIds.map((fieldLinkId) => (
          <GroupedColumn
            key={fieldLinkId}
            parentId={fieldLink.primary ? fieldLinkId : primaryFieldLink.id}
            subParentId={isMultiGrouping && !fieldLink.primary ? fieldLinkId : null}
          />
        ))
      )}
    </Wrapper>
  )
}

export default TableForm
